<p style="padding: 16px">Access Token: <span style="width: 100%; overflow: hidden; word-wrap: break-word;">{{data?.token ||
        "Token não definido."}}</span></p>